export function getMessage(obj) {
    let message = '';
    Object.keys(obj).forEach(key => {
        message += `${obj[key]} <br>`;
    })

    return message;
}



// WEBPACK FOOTER //
// ./src/composables/message.js